import React, { useState } from "react";
import managerAvatar from "../../../../../img/manageravatar.png";
import NarayanganjAddressSelect from "../../../../../Components/AddressAutocomplete";
import { useDispatch, useSelector } from "react-redux";
import { managerRegister, SendPassword } from "../../../../../Redux/auth/action";
import Sidebar from "../../GlobalFiles/Sidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Navigate } from "react-router-dom";
const notify = (text) => toast(text);

const Add_Manager = () => {
  const { data } = useSelector((store) => store.auth);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const InitData = {
    managerName: "",
    age: "",
    mobile: "",
    email: "",
    gender: "",
    DOB: "",
    address: "",
    education: "",
    department: "",
    managerID: Date.now(),
    password: "",
    details: "",
    bloodGroup: "",
  };
  const [managerValue, setmanagerValue] = useState(InitData);

  const HandleDoctorChange = (e) => {
    setmanagerValue({ ...managerValue, [e.target.name]: e.target.value });
  };

  const HandleDoctorSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(managerRegister(managerValue)).then((res) => {
      if (res.message === "Manager already exists") {
        setLoading(false);
        return notify("Manager Already Exist");
      }
      if (res.message === "error") {
        setLoading(false);
        return notify("Something went wrong, Please try Again");
      }
      notify("Manager Added");

      let data = {
        email: res.data.email,
        password: res.data.password,
        userId: res.data.managerID,
      };
      // console.log(data);
      dispatch(SendPassword(data)).then((res) => notify("Account Detais Sent"));
      setLoading(false);
      setmanagerValue(InitData);
    });
  };

  if (data?.isAuthticated === false) {
    return <Navigate to={"/"} />;
  }

  if (data?.user.userType !== "admin") {
    return <Navigate to={"/dashboard"} />;
  }

  return (
    <>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
      <div className="flex min-h-screen bg-gray-50">
        <Sidebar onCollapse={setSidebarCollapsed} />
        <div className={`flex-1 p-6 transition-all duration-300 ${sidebarCollapsed ? 'ml-20' : 'ml-0'}`}>
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <h1 className="text-3xl font-bold text-gray-800 text-center mb-6">Add Manager</h1>
            <div className="flex justify-center mb-8">
              <img src={managerAvatar} alt="manager" className="w-24 h-24 rounded-full object-cover border-4 border-blue-500" />
            </div>
            <form onSubmit={HandleDoctorSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Name *</label>
                <div>
                  <input
                    type="text"
                    placeholder="Full Name"
                    name="managerName"
                    value={managerValue.managerName}
                    onChange={HandleDoctorChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Age *</label>
                <div>
                  <input
                    type="number"
                    placeholder="Age"
                    name="age"
                    value={managerValue.age}
                    onChange={HandleDoctorChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Contact Number *</label>
                <div>
                  <input
                    type="number"
                    placeholder="Emergency Number"
                    name="mobile"
                    value={managerValue.mobile}
                    onChange={HandleDoctorChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                <div>
                  <input
                    type="email"
                    placeholder="abc@abc.com"
                    name="email"
                    value={managerValue.email}
                    onChange={HandleDoctorChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Gender *</label>
                <div>
                  <select
                    name="gender"
                    value={managerValue.gender}
                    onChange={HandleDoctorChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="Choose Gender">Choose Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Birthdate </label>
                <div>
                  <input
                    type="date"
                    placeholder="dd-mm-yy"
                    name="DOB"
                    value={managerValue.DOB}
                    onChange={HandleDoctorChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Address </label>
                <NarayanganjAddressSelect
                  value={managerValue.address}
                  onChange={val => setmanagerValue({ ...managerValue, address: val })}
                  placeholder="Type to search or select address in Narayanganj..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Education </label>
                <div>
                  <input
                    type="text"
                    placeholder="eg. BSS"
                    name="education"
                    value={managerValue.education}
                    onChange={HandleDoctorChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Blood Group </label>
                <div>
                  <select
                    name="bloodGroup"
                    value={managerValue.bloodGroup}
                    onChange={HandleDoctorChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="Choose Blood Group">Select</option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="AB+">AB+</option>
                    <option value="AB-">AB-</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Password *</label>
                <div>
                  <input
                    type="text"
                    placeholder="Password"
                    name="password"
                    value={managerValue.password}
                    onChange={HandleDoctorChange}
                    required
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
              <button 
                type="submit" 
                disabled={loading}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
              >
                {loading ? "Loading..." : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Add_Manager;